import React from 'react';
import PropTypes from 'prop-types';
import { Spring } from 'react-spring';
import * as easings from 'd3-ease';

const RevealEdges = ({ isInView }) => {
  const animationConfig = {
    delay: 300,
    duration: 900,
    easing: easings.easeCubicOut,
  };
  const edges = animation => {
    return (
      <React.Fragment>
        <div
          style={{
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: animation.right,
            zIndex: 2,
            background: 'rgb(240, 240, 242)',
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: animation.left,
            right: '0',
            zIndex: 2,
            background: 'rgb(240, 240, 242)',
          }}
        />
      </React.Fragment>
    );
  };
  return (
    <Spring
      from={{ left: '95%', right: '95%' }}
      to={{
        left: isInView ? '100%' : '95%',
        right: isInView ? '100%' : '95%',
      }}
      config={animationConfig}
    >
      {animation => edges(animation)}
    </Spring>
  );
};

RevealEdges.propTypes = {
  isInView: PropTypes.bool,
};

export default RevealEdges;



// WEBPACK FOOTER //
// ./src/components/animations/reveal-edges/index.js